import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';

import { useAssignmentActions } from '../../contexts/assignment-actions-context';
import { useTimeoffOverlapStore } from '../../store/timeoff-overlap.store';

export function TimeoffOverlapConfirmationModal() {
  const { t } = useTranslation('authenticated.planner', {
    keyPrefix: 'modals.timeoffOverlap',
  });
  const { deleteMutation } = useAssignmentActions();
  const { data, close } = useTimeoffOverlapStore();

  const handleConfirm = async (closeModal: () => void) => {
    if (!data?.assignmentId) return;

    await deleteMutation.mutateAsync({
      payload: { assignmentId: data.assignmentId },
      ui: { userName: data.userName, projectName: data.projectName },
    });
    close();
    closeModal();
  };

  return (
    <ConfirmationModal
      title={t('title')}
      message={t('message')}
      confirmText={t('confirm')}
      cancelText={t('cancel')}
      confirmVariant="destructive"
      open={data !== null}
      onOpen={() => {}}
      onClose={close}
      onConfirm={handleConfirm}
      isLoading={deleteMutation.isPending}
    />
  );
}
